import React from 'react'
import { Route, Switch } from 'react-router-dom'

import AccountSubscription from './pages/AccountSubscription'

const Account = () => {
    return (
        <Switch>
            <Route path="/account" exact component={AccountSubscription} />
            <Route path="/account/subscription" exact component={AccountSubscription} />
            <Route path="/account/subscription/:freetrial" component={AccountSubscription} />
        </Switch>
    )
}

export default Account
